<template>
  <div class="c-link-list__item">
    <div class="text-wrap">
      <sc-link
        v-if="fields && fields.link"
        :field="fields.link"
        class="c-link-list__link"
        :class="fields.link.value.class"
      />
      <sc-text
        v-if="fields && fields.description"
        :field="fields.description"
        class="c-link-list__desc"
      />
    </div>
    <div class="link-wrap">
      <sc-link
        v-if="fields && fields.linkBottomOne"
        :field="fields.linkBottomOne"
        class="c-link-list__link--bottom c-cta--tertiary"
        :class="fields.linkBottomOne.value.class"
      />
      <sc-link
        v-if="fields && fields.linkBottomTwo"
        :field="fields.linkBottomTwo"
        class="c-link-list__link--bottom c-cta--tertiary"
        :class="fields.linkBottomTwo.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Link, Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Link-Extra-Links',
  components: {
    ScLink: Link,
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.c-link-list {
  &__item {
    .c-cta {
      &--tertiary {
        min-width: 12rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        padding: 0.5rem 0;
        margin: 0;
        &:after {
          top: 0.25rem;
        }
        &:hover {
          &:after {
            left: 1rem;
          }
        }
      }
    }
  }
}
</style>
